<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model.number="item.input"
            :error-messages="inputErrors"
            :label="$t('profile.material.input')"
            required
            @input="$v.item.input.$touch()"
            @blur="$v.item.input.$touch()"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="mediumSelectItems"
            v-model="item.medium"
            :items="mediumSelectItems"
            :error-messages="mediumErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.material.medium')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="feedSpecSelectItems"
            v-model="item.feedSpec"
            :items="feedSpecSelectItems"
            :error-messages="feedSpecErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('profile.material.feedspec')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

      </v-row>

    </v-container>
        <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'MaterialSupplySubForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.mediumGetSelectItems();
      this.feedSpecGetSelectItems();
      this.materialSupplyGetSelectItems();
  },
  data() {
    return {
        input: null,
        medium: null,
        feedSpec: null,
        materialSupply: null,
    };
  },
  computed: {
      isLoading() {
        return (this.isLoading_materialmedium ||
           this.isLoading_materialfeedspec ||
           this.isLoading_materialsupply
         );
      },
      ...mapFields('materialmedium', {
        mediumSelectItems: 'selectItems',
        isLoading_materialmedium : 'isLoading'
      }),
      ...mapFields('materialfeedspec', {
        feedSpecSelectItems: 'selectItems',
        isLoading_materialfeedspec : 'isLoading'
      }),
      ...mapFields('materialsupply', {
        materialSupplySelectItems: 'selectItems',
        isLoading_materialsupply : 'isLoading'
      }),

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    inputErrors() {
      const errors = [];

      if (!this.$v.item.input.$dirty) return errors;

      has(this.violations, 'input') && errors.push(this.violations.input);

      !this.$v.item.input.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    mediumErrors() {
      const errors = [];

      if (!this.$v.item.medium.$dirty) return errors;

      has(this.violations, 'medium') && errors.push(this.violations.medium);


      return errors;
    },
    feedSpecErrors() {
      const errors = [];

      if (!this.$v.item.feedSpec.$dirty) return errors;

      has(this.violations, 'feedSpec') && errors.push(this.violations.feedSpec);


      return errors;
    },
    materialSupplyErrors() {
      const errors = [];

      if (!this.$v.item.materialSupply.$dirty) return errors;

      has(this.violations, 'materialSupply') && errors.push(this.violations.materialSupply);


      return errors;
    },

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      ...mapActions({
        mediumGetSelectItems: 'materialmedium/fetchSelectItems'
      }),
      ...mapActions({
        feedSpecGetSelectItems: 'materialfeedspec/fetchSelectItems'
      }),
      ...mapActions({
        materialSupplyGetSelectItems: 'materialsupply/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      input: {
        required,
      },
      medium: {
      },
      feedSpec: {
      },
      materialSupply: {
      },
    }
  }
};
</script>
